module.exports = __webpack_public_path__ + "media/heeman-poster.b096d4a8.mp4";